import { render, staticRenderFns } from "./MagicLinkPost.vue?vue&type=template&id=4eb4c1c2&scoped=true&"
import script from "./MagicLinkPost.vue?vue&type=script&lang=js&"
export * from "./MagicLinkPost.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkPost.vue?vue&type=style&index=0&id=4eb4c1c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb4c1c2",
  null
  
)

component.options.__file = "MagicLinkPost.vue"
export default component.exports